export default __webpack_public_path__ + "static/waves-bg-41333344fec24b5c6d00da48de951205.svg";